import styled from '@emotion/styled';
import {
  Row,
  Column,
  Divider,
  device,
  typography,
  Reveal,
  mobileGutterMargin,
} from '@landsbankinn/ui';
import React from 'react';
import type { ImgSource, ImgAr } from '../../components/img/Img';
import { Img } from '../../components/img/Img';

export const Host = styled(Reveal)`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  position: relative;
  width: 100%;

  margin-bottom: 90px;

  background-color: ${(props) => props.theme.colors.background};

  &:last-child {
    margin-bottom: 0;
  }
`;

const BigRow = styled(Row)`
  width: 100%;
`;

const ImageWrapper = styled.div`
  margin-left: ${(props) => `-${props.theme.containerGutter}px`};
  margin-right: ${(props) => `-${props.theme.containerGutter}px`};
  margin-bottom: 30px;

  ${mobileGutterMargin}

  @media ${device.tablet} {
    margin: 0;
  }
`;

const Header = styled.div`
  margin-bottom: 40px;

  @media ${device.tablet} {
    margin-top: 54px;
  }
`;

const Name = styled.h2`
  ${typography.h3};
  margin-bottom: 20px;

  @media ${device.tablet} {
    margin-bottom: 8px;
  }
`;

const Title = styled.div`
  font-family: ${(props) => props.theme.font.familySerifCond};
  font-weight: 500;
  margin-bottom: 33px;
`;

const Bio = styled.div``;

export interface CardProps {
  image?: ImgSource;
  ar?: ImgAr;
  name: string | null;
  title: string | null;
  bio: React.ReactNode;
}

export const StaffBioCard = ({
  image,
  ar = 'ar_1_1',
  name,
  title,
  bio,
}: CardProps) => {
  return (
    <Host>
      <BigRow>
        {!!image && (
          <Column md={{ width: 5 / 12 }} lg={{ width: 6 / 12 }}>
            <ImageWrapper>
              <Img
                alt={title ?? undefined}
                src={image}
                ar={ar}
                percentage={4 / 12}
              />
            </ImageWrapper>
          </Column>
        )}
        <Column
          md={{ width: 6 / 12, offset: !!image ? 1 / 12 : 0 }}
          lg={{ width: 5 / 12, offset: !!image ? 1 / 12 : 0 }}
        >
          <Header>
            <Name>{name}</Name>
            {title && <Title>{title}</Title>}
            <Divider />
          </Header>

          <Bio>{bio}</Bio>
        </Column>
      </BigRow>
    </Host>
  );
};
